import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getProfileDisplayRoles } from "common/Utilities/Role.utils";
import SettingsIcon from '@mui/icons-material/Settings';
import { AdminPanelSettings } from "@mui/icons-material";
import { useEffectiveAccess } from "common/Context/EffectiveAccessContext";
import { EFFECTIVE_ACCESS_PAGE_KEY } from "common/Constants/EffectiveAccess.constants";
import {
  StyledMenu,
  ProfileAvatarContainer,
  StyledProfileAvatar,
  ProfileInfoSection,
  MenuSectionsContainer,
  UserName,
  UserEmail,
  RolePill,
  RolesPillsContainer,
  RolesPanelSubtitle,
  UserPhone,
  StyledDivider,
  StyledAccordion,
  StyledAccordionSummary,
  AccordionSummaryRow,
  AccordionTitleBlock,
  AccountSettingsLabel,
  StyledHelpIcon,
  HelpLabel,
  StyledAccordionDetails,
  RolesAccordionDetails,
  LogoutSection,
  LogoutButton,
} from "./ProfileMenu.style";
import { userInfoConstants } from "./UserInfoConstants";

const ProfileMenu = ({ anchorElUser, handleCloseUserMenu, userProfile }) => {
  const { profile = {} } = userProfile || {};
  const {
    name: username = "",
    mobile_number = "",
    email = "",
    id = "",
  } = profile;

  const userEmail = email.toLowerCase();
  const displayRoles = getProfileDisplayRoles(profile);
  const { canAccessPage, usesEffectiveAccess } = useEffectiveAccess();

  const showAdministrationAccess =
  (usesEffectiveAccess &&
    (canAccessPage(EFFECTIVE_ACCESS_PAGE_KEY.USER_MANAGEMENT) ||
      canAccessPage(EFFECTIVE_ACCESS_PAGE_KEY.DATA_MANAGEMENT)));

  return (
    <StyledMenu
      id="menu-appbar"
      anchorEl={anchorElUser}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(anchorElUser)}
      onClose={handleCloseUserMenu}
    >
      {Boolean(anchorElUser) && (
        <ProfileAvatarContainer>
          <StyledProfileAvatar alt="Profile Icon" src="" />
        </ProfileAvatarContainer>
      )}

      <ProfileInfoSection>
        <UserName>{username || id}</UserName>
        <UserEmail>{userEmail}</UserEmail>
        <UserPhone>{mobile_number}</UserPhone>
      </ProfileInfoSection>

      <StyledDivider />
      <MenuSectionsContainer>
        <StyledAccordion>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="assigned-roles-content"
            id="assigned-roles-header"
          >
            <AccordionSummaryRow>
              <AdminPanelSettings fontSize="large" />
              <AccordionTitleBlock>
                <AccountSettingsLabel variant="body1">Roles</AccountSettingsLabel>
                <RolesPanelSubtitle>
                  {displayRoles.length} Assigned
                </RolesPanelSubtitle>
              </AccordionTitleBlock>
            </AccordionSummaryRow>
          </StyledAccordionSummary>
          <RolesAccordionDetails>
            <RolesPillsContainer>
              {displayRoles.map((role, index) => (
                <RolePill key={`${role}-${index}`}>{role}</RolePill>
              ))}
            </RolesPillsContainer>
          </RolesAccordionDetails>
        </StyledAccordion>

        <StyledAccordion>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="account-settings-content"
            id="account-settings-header"
          >
            <AccordionSummaryRow>
              <SettingsIcon fontSize="large" />
              <AccountSettingsLabel variant="body1">
                <span style={{ marginLeft: "8px" }}>{userInfoConstants.dropdownOptions.accountSettings}</span>
              </AccountSettingsLabel>
            </AccordionSummaryRow>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            <MenuItem onClick={() => handleCloseUserMenu("Reset Password")}>
              <Typography textAlign="center">{userInfoConstants.dropdownOptions.resetPassword}</Typography>
            </MenuItem>
            {showAdministrationAccess && (
              <MenuItem onClick={() => handleCloseUserMenu("Administration")}>
                <Typography textAlign="center">{userInfoConstants.dropdownOptions.administration}</Typography>
              </MenuItem>
            )}
          </StyledAccordionDetails>
        </StyledAccordion>

        <StyledAccordion>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="help-content"
            id="help-header"
          >
            <AccordionSummaryRow>
              <StyledHelpIcon />
              <HelpLabel variant="body1">Help</HelpLabel>
            </AccordionSummaryRow>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            <MenuItem>
              <Typography textAlign="center" fontSize={14}>
                {userInfoConstants.dropdownOptions.helpNumber}
              </Typography>
            </MenuItem>
          </StyledAccordionDetails>
        </StyledAccordion>
      </MenuSectionsContainer>

      <LogoutSection>
        <LogoutButton
          variant="contained"
          onClick={() => handleCloseUserMenu("Logout")}
        >
          {userInfoConstants.buttonName.signOut}
        </LogoutButton>
      </LogoutSection>
    </StyledMenu>
  );
};

ProfileMenu.propTypes = {};

export default ProfileMenu;
